export const personalSkills = [
  { type: "Impresion", level: 65 },
  { type: "Sublimación", level: 65 },
  { type: "Corte Vinil", level: 65 },
  { type: "Identidad Corporativa", level: 80 },
  { type: "Render 3D", level: 80 },
  { type: "SocialMedia", level: 80 },
]
export const personalSkillsColors = {
  bar: "#845ef7",
  title: {
    text: "#fff",
    background: "#6741d9",
  },
}
export const frontendSkills = [
  { type: "Photoshop", level: 70 },
  { type: "Ilustrator", level: 80 },
  { type: "Premiere", level: 50 },
  { type: "AfterEffects", level: 50 },
  { type: "InDesign", level: 60 },
  { type: "Lightroom", level: 70 },
  { type: "Cinema4D", level: 70 },
]
export const frontendSkillsColors = {
  bar: "#3498db",
  title: {
    text: "#fff",
    background: "#2980b9",
  },
}

export const backendSkills = [
  { type: "MacOs", level: 80 },
  { type: "Windows", level: 60 },
]
export const backendSkillsColors = {
  bar: "#00bd3f",
  title: {
    text: "#fff",
    background: "#009331",
  },
}
